export default "__VITE_PUBLIC_ASSET__1ea53cec__"